'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Testimonial {
  id: number;
  name: string;
  title: string;
  company: string;
  quote: string;
  fleetSize: string;
}

const VideoTestimonials = () => {
  const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Michael Rodriguez',
    title: 'Fleet Operations Manager',
    company: 'Metro Logistics Inc.',
    quote: 'National Fleet Surplus got us 22% more than our auction estimate. The process was transparent and incredibly fast.',
    fleetSize: '35 Vehicles'
  },
  {
    id: 2,
    name: 'Sarah Chen',
    title: 'CFO',
    company: 'Regional Transport Solutions',
    quote: 'The dedicated account manager made our fleet transition seamless. Highly recommend for any business.',
    fleetSize: '48 Vehicles'
  },
  {
    id: 3,
    name: 'James Patterson',
    title: 'Owner',
    company: 'Patterson Delivery Services',
    quote: 'After 30 years in business, this was the easiest fleet sale I\'ve ever done. Professional from start to finish.',
    fleetSize: '12 Vehicles'
  }];

  return (
    <section className="bg-card py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Hear From Fleet Managers Like You
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Real stories from businesses who chose National Fleet Surplus for their vehicle sales.
          </p>
        </div>

        {/* Review Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) =>
          <div
            key={testimonial.id}
            className="bg-background rounded-xl overflow-hidden shadow-md hover:shadow-brand transition-all duration-200 p-6">

              {/* Fleet Size Badge */}
              <div className="flex justify-end mb-4">
                <div className="px-3 py-1 bg-accent text-accent-foreground text-xs font-semibold rounded-full">
                  {testimonial.fleetSize}
                </div>
              </div>

              {/* Quote */}
              <div className="mb-6">
                <p className="text-base text-foreground leading-relaxed italic">
                  "{testimonial.quote}"
                </p>
              </div>

              {/* Rating */}
              <div className="flex items-center space-x-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) =>
                  <Icon key={star} name="StarIcon" size={20} variant="solid" className="text-accent" />
                )}
              </div>

              {/* Author Info */}
              <div className="pt-4 border-t border-border">
                <p className="text-sm font-semibold text-foreground">{testimonial.name}</p>
                <p className="text-xs text-muted-foreground">{testimonial.title}</p>
                <p className="text-xs text-muted-foreground">{testimonial.company}</p>
              </div>
            </div>
          )}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <p className="text-base text-muted-foreground mb-6">
            Join hundreds of satisfied fleet managers who maximized their vehicle values
          </p>
          <button className="px-8 py-4 bg-primary text-primary-foreground font-semibold rounded-lg hover:bg-opacity-90 transition-all duration-200 ease-out hover:-translate-y-1 shadow-brand inline-flex items-center space-x-2">
            <span>Share Your Success Story</span>
            <Icon name="ChatBubbleLeftRightIcon" size={20} variant="outline" />
          </button>
        </div>
      </div>
    </section>);

};

export default VideoTestimonials;